import React from 'react';
import { Building2, Search, MapPin, TrendingUp, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';

const RealEstate = () => {
  const features = [
    { icon: Search, title: 'Property Listings', description: 'Advanced search and filtering for properties' },
    { icon: MapPin, title: 'Location Mapping', description: 'Interactive maps with property locations' },
    { icon: TrendingUp, title: 'Market Analytics', description: 'Real-time market trends and insights' },
    { icon: Building2, title: 'Virtual Tours', description: '360° property tours and virtual showings' }
  ];

  return (
    <div className="min-h-screen bg-gray-950 pt-20">
      <section className="py-20 bg-gradient-to-b from-gray-900 to-gray-950">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-block bg-cyan-500/10 border border-cyan-500/20 rounded-full px-4 py-2 mb-6">
              <span className="text-cyan-400 text-sm font-medium">Real Estate</span>
            </div>
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
              Smart <span className="bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent">Real Estate Platforms</span>
            </h1>
            <p className="text-xl text-gray-400 mb-8">
              Build powerful property management and listing platforms with virtual tours and advanced search capabilities.
            </p>
            <Button className="bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 text-white px-8 py-6 text-lg rounded-lg">
              Get Started <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gray-950">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {features.map((feature, index) => (
              <div key={index} className="bg-gradient-to-br from-gray-800/50 to-gray-800/30 backdrop-blur-sm border border-gray-700 rounded-2xl p-6 hover:border-cyan-500 transition-all duration-300">
                <div className="w-14 h-14 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-xl flex items-center justify-center mb-4">
                  <feature.icon className="w-7 h-7 text-white" />
                </div>
                <h3 className="text-xl font-bold text-white mb-3">{feature.title}</h3>
                <p className="text-gray-400 text-sm">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default RealEstate;